import { useContext } from "react";
import PlaylistModalContext from "../contexts/playlist-modal-context/PlaylistModalContext";

export const usePlaylistModal = () => {
  const context = useContext(PlaylistModalContext);
  if (context === undefined) {
    throw new Error('usePlaylistModal must be used within a PlaylistModalProvider');
  }
  
  return context;
};